import Entity from '../../../../../../foundation/domain/Entity';
import EntityId from '../../../../../../foundation/domain/EntityId';
import * as Voca from 'voca';
import User from '../../../../users/domain/aggregates/user/User';
import CourseVisibility from './CourseVisibility';

export default class Course extends Entity<Course> {

	public constructor (id: EntityId<Course>, private userId: EntityId<User>, private name: string, private visibility: CourseVisibility) {
		super(id);
	}

	public static create (userId: EntityId<User>, visibility: CourseVisibility) {
		return new Course(EntityId.create<Course>(), userId, '', visibility);
	}

	/*
	 * Query methods
	 */

	public getUserId () {
		return this.userId;
	}

	public isPublic () {
		return this.getVisibility().isPublic();
	}

	public getName () {
		return this.name;
	}

	public getVisibility () {
		return this.visibility;
	}

	public getSlug () {
		return '/course/' + this.getId().getValue() + '/' + Voca.slugify(this.name);
	}

	/*
	 * Command methods
	 */

	public updateName (name: string) {
		this.name = name;
		return this;
	}

	public updateVisibility (visibility: CourseVisibility) {
		this.visibility = visibility;
		return this;
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/lessons/domain/aggregates/course/Course.ts